import React, { useEffect } from 'react';
import './MobileQuickFilter.scss';
import { filterHelperMobileSelections } from '../FilterPanel.helper';
import { useSelector } from 'react-redux';
import { odPushGA4Event } from '../../../../../utils/gaFour';

const MobileQuickFilter = ({
  filterDataList,
  categoryID,
  categoryActions,
  selectedOptions,
  setSelectedOptions,
  mobilePendingSelections,
  setMobilePendingSelections,
}) => {
  const userInfo = useSelector(state => state.common.userInfo);

  const toggleOption = (filterId, optionId) => {
    odPushGA4Event('filter_option_click', {
      userInfo,
      [filterId]: optionId,
    });

    setMobilePendingSelections(prev => {
      const prevSelected = prev[filterId] || [];
      const exists = prevSelected.includes(optionId);
      const updated = exists
        ? prevSelected.filter(id => id !== optionId)
        : [...prevSelected, optionId];

      return {
        ...prev,
        [filterId]: updated,
      };
    });
  };

  const filtersToShow = ['Colour', 'Price', 'Brand', 'Frame Shape'];

  const getFilterOptions = id => {
    return filterDataList?.result?.filters?.find(filter => filter.id === id);
  };

  const filterIdMap = {
    Colour: 'frame_color_id',
    Price: 'lenskart_price',
    Brand: 'brandname_id',
    'Frame Shape': 'frame_shape_id',
  };

  const hasSelectedFilters = Object.values(mobilePendingSelections).some(arr => arr.length > 0);

  useEffect(() => {
    const preloadSelections = {};
    ['frame_color_id', 'lenskart_price', 'brandname_id', 'frame_shape_id'].forEach(id => {
      if (selectedOptions[id]?.length > 0) {
        preloadSelections[id] = [...selectedOptions[id]];
      }
    });
    setMobilePendingSelections(preloadSelections);
  }, [selectedOptions]);

  const applyMobileSelections = () => {
    setSelectedOptions(mobilePendingSelections);

    filterHelperMobileSelections({
      mobilePendingSelections,
      filterResult: filterDataList?.result?.filters,
      setSelectedOptions,
      addFilterData: categoryActions?.addFilterData,
      categoryID,
      getCategoryData: categoryActions?.getCategoryData,
      setShowFilterMobile: () => {},
    });

    odPushGA4Event('filter_applied', {
      userInfo,
      ...mobilePendingSelections,
    });
  };

  return (
    <div className="mobile-filter">
      <div className="mobile-filter__header">
        <span className="mobile-filter__icon" />
        <h2 className="mobile-filter__title">Filter by</h2>
      </div>

      {filtersToShow.map(label => {
        const filterId = filterIdMap[label];
        const filter = getFilterOptions(filterId);

        if (!filter || !filter.data || !filter.data[0]?.options?.length) return null;

        return (
          <div key={filter.id} className="mobile-filter__section">
            <div className="mobile-filter__label">{label}</div>
            <div className="mobile-filter__option-group">
              {filter.data[0].options.map(option => {
                const selectedList = mobilePendingSelections[filter.id] || [];
                const isActive = selectedList.includes(option.id);

                let baseClass = 'mobile-filter__option';
                if (label === 'Frame Shape') {
                  baseClass = 'mobile-filter__option--image';
                } else if (label === 'Colour') {
                  baseClass = 'mobile-filter__option mobile-filter__option--color';
                }

                return (
                  <button
                    key={option.id}
                    className={`${baseClass}${isActive ? ' active' : ''}`}
                    onClick={() => toggleOption(filter.id, option.id)}
                  >
                    {label === 'Colour' && (
                      <img
                        alt={option.title}
                        className="mobile-filter__color-circle"
                        src={option.imageUrl}
                      />
                    )}
                    {label === 'Frame Shape' && <img alt={option.title} src={option.imageUrl} />}
                    {option.title}
                    <span
                      className={
                        label === 'Colour'
                          ? 'mobile-filter__option--count--2'
                          : 'mobile-filter__option--count'
                      }
                    >
                      ({option.noOfProducts})
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}

      <button
        className={`mobile-filter__submit${hasSelectedFilters ? ' active' : ''}`}
        disabled={!hasSelectedFilters}
        onClick={applyMobileSelections}
      >
        Show Products
      </button>
    </div>
  );
};

export default MobileQuickFilter;
